import { createSelector } from 'reselect';

import { RootState } from '@/app/store';

const selectPreferencesState = (state: RootState) => state.preferences;

export const selectSelectedCurrency = (state: RootState) =>
  state.preferences.selectedCurrency;

export const selectQuickBuyPresets = createSelector(
  selectPreferencesState,
  (s) => s.quickBuyPresets,
);
